var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { Integrations } from '@sentry/tracing';
import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';

const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;
const RELEASE = process.env.NEXT_PUBLIC_RELEASE;
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_LOGGING_EVENT_LEVEL = (process.env.NEXT_PUBLIC_SENTRY_LOGGING_EVENT_LEVEL || 'warning') as Sentry.SeverityLevel;
const SENTRY_SAMPLE_RATE = Number(process.env.SENTRY_SAMPLE_RATE) || 1;
const SENTRY_TRACES_SAMPLE_RATE = Number(process.env.SENTRY_TRACES_SAMPLE_RATE) || ENVIRONMENT === 'production' ? 0.02 : 1.0;
const SENTRY_ENVIRONMENT = process.env.SENTRY_ENVIRONMENT || ENVIRONMENT;

const ignoreErrors = [
  // known issue
  'attempted to hard navigate to the same URL', // next.js 버그
];

if (process.env.NEXT_PUBLIC_DEBUG === 'true' || ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: RELEASE,
    sampleRate: SENTRY_SAMPLE_RATE,
    integrations: [
      new Integrations.BrowserTracing(),
      new ExtraErrorDataIntegration({
        // limit of how deep the object serializer should go. Anything deeper than limit will
        // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
        // a primitive value. Defaults to 3.
        depth: 10,
      }),
    ],
    beforeSend(event, hint) {
      const err = hint.originalException;
      const check = (key: 'name' | 'message') => {
        const value =  err instanceof Error ? err[key] : err;
        if (typeof value === 'string' && ignoreErrors.some(error => value.indexOf(error) >= 0)) {
          return true;
        }
      };
      if (check('name') || check('message')) {
        return null;
      }
      return event;
    },
    beforeBreadcrumb: (breadcrumb, hint) => {
      // make xhr category verbose
      if (breadcrumb.category === 'xhr' && hint?.xhr) {
        // filter responses
        return {
          type: breadcrumb.type,
          level: breadcrumb.level,
          category: breadcrumb.category,
          data: {
            ...breadcrumb.data,
            response: hint.xhr.response,
            method: hint.xhr.__sentry_xhr__.method,
            url: hint.xhr.__sentry_xhr__.url,
            statusCode: hint.xhr.__sentry_xhr__.status_code,
            statusText: hint.xhr.statusText,
            body: hint.xhr.__sentry_xhr__.body,
          },
        } as Sentry.Breadcrumb;
      }
      return breadcrumb;
    },
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    maxBreadcrumbs: 200,
    maxValueLength: 300,
    normalizeDepth: 10,
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    debug: ENVIRONMENT !== 'production',
  });
  Sentry.configureScope(scope => scope.setLevel(SENTRY_LOGGING_EVENT_LEVEL))
}
